module.exports = __webpack_public_path__ + "img/homeLogo.c9e771d1.svg";